module.exports = __webpack_public_path__ + "img/Newbie_Sword_02_Ranger.a6373ecd.png";